import { gql } from '@apollo/client';

export const GET_TOTAL_PACK_COUNT_QUERY = gql`
  query GetTotalPackCount($packTypeId: Float!) {
    getTotalPackCount(packTypeId: $packTypeId) {
      packTypeId
      totalPacks
    }
  }
`;
